// function setEqualHeight(columns){
//     var tallestcolumn = 0;
//     columns.each(function(){
//         $(this).height('auto');
//         currentHeight = $(this).height();
//         if(currentHeight > maxHeight){
//             $(this).addClass('gray-hid');
//         }
//         if(currentHeight > tallestcolumn){
//             tallestcolumn = currentHeight;
//         }
//     });
//     if (tallestcolumn > maxHeight) {
//         columns.height(maxHeight);
//     } else {
//         columns.height(tallestcolumn);
//     }    
// }

// function initSetEqualHeight(){
//     setEqualHeight($('.upcoming-title-2lines'));
//     setEqualHeight($('.upcoming-author'));    
// }

$(document).ready(function () {
    // $('.secondary-products .product-check-list li').each(function (index) {

    //     var height = $(this).outerHeight();
    //     index = ++index
    //     console.log(index);
    //     $('.main-products .product-check-list li').eq(index).outerHeight(height);
    // });

    $('.open-join-form').addClass('show').removeClass('hide');
    $('.authors-join').addClass('hide').removeClass('show');


    $('.open-join-form').on('click', function () {
        if (Auth.getIdentity().hasIdentity()) {
            var l = Ladda.create(this);
            l.start();
            Auth.isntUserHasB2bRole(showJoinForm, function (response) {
                show_alert(response.message, response.status);
            });
        } else {
            showJoinForm();
        }
    });

    $('.close').on('click', function () {
        $(this).parent().addClass('hide').removeClass('show');
        $('.open-join-form').removeClass('hide').addClass('show');
        $('.contact').addClass('show').removeClass('hide');
    });

    //scroll to block by hash 
    $('.to-section[href*="#"]').bind("click", function (e) {
        var anchor = $(this);
        var id = anchor.attr('href').replace(new RegExp("#", 'gi'), '');
        $('html, body').stop().animate({
            scrollTop: $('a[id=' + id + ']').offset().top - 50
        }, 1000);
        window.location.hash = id;
        e.preventDefault();
        return false;
    });


    if (window.location.hash.length > 0) {
        if (window.location.hash === '#register') {
            $('#join-window').fadeIn();
            if (showForm === 0) {
                initiateRegistration('b2b');
            }
            showForm++;
            window.cbShowJoinForm();
        } else {
            setTimeout(function () {
                $('.to-section[href="' + window.location.hash + '"]').eq(0).click();
            }, 500);
        }
    }

    $('.close-btn').on('click', function () {
        $('.block-scheme-mobile .unit').hide();
    });
    $('.contact-btn').on('click', function () {
        $('#contact').show();
    });
    $('.c-close, .yc-return').on('click', function () {
        $('#contact').hide();
    });

    $('.b2b-contact-form .cb-form-control').tooltipster({
        trigger: 'custom',
        onlyOne: false,
        position: 'top-right',
        offsetX: 13
    });

    $('.b2b-contact-form form').validate({
        errorPlacement: function (error, element) {
            $(element).tooltipster('update', $(error).text());
            $(element).tooltipster('show');
        },
        success: function (label, element) {
            $(element).tooltipster('hide');
        },
        rules: {
            first_name: {
                required: true,
                minlength: 3,
                maxlength: 30
            },
            last_name: {
                required: true,
                minlength: 3,
                maxlength: 30
            },
            email: {
                required: true,
                email: true
            },
            b2b_company: {
                required: false,
                minlength: 3,
                maxlength: 100
            },
            b2b_message: {
                required: false,
                minlength: 6,
                maxlength: 255
            }
        },
        messages: {

            first_name: {
                required: "Please specify your name",
                first_name: "Sorry, the name is too short (3 characters min and 30 characters max)"

            },
            last_name: {
                required: "Please specify your last name",
                last_name: "Sorry, the last name is too short (3 characters min and 30 characters max)"

            },
            email: {
                required: "We need your email address to contact you",
                email: "Your email address must be in the format of name@domain.com"
            },
            b2b_company: {
                b2b_company: "Please enter at least 3 characters."

            },
            b2b_message: {
                b2b_message: "Please enter at least 6 characters."
            }
        },
        submitHandler: function (form) {
            return false;
        }
    });
    // fix label if input not empty
    function labelFix() {
        $('.b2b-form-control, cb-form-control').each(function () {

            $(this).on('keyup click', function () {

                var val = $(this).val();
                if (val != null && val.length > 0) {
                    $(this).parent().find('label').addClass('not-empty');
                } else {
                    $(this).parent().find('label').removeClass('not-empty');
                }

            });
        });
    }

    labelFix();

    $('.display-name').on('click', function () {
        $('.dropdown').slideToggle('slow');
        $(this).toggleClass('active');
        $(this).parents('.user-account-list').toggleClass('active bg');
    });

    $(document).on('click', function (e) {
        var container = $('.user-account-list');
        if ($('.dropdown').is(':visible') && container.has(e.target).length === 0) {
            $('.dropdown').slideUp('slow');
        }
    });

    $('.show-popup').on('click', function (e) {
        var l = Ladda.create(this);
        l.start();
        var popup = $(this).data('popup');
        if (popup === 'join-window') {
            labelFix();
        }

        // save competition property for book
        if ($(this).attr('data-page') === 'competition') {
            $.ajax({
                url: window.Config.BASE_PATH + '/api/v1/book/save-book-competition',
                type: 'post',
                dataType: 'json'
            });
        }

        // save competition property for book
        var param = '';
        if ($(this).attr('data-page') === 'writing-contest') {
            if ($(this).attr('data-action') === 'writingcontest2019page') {
                //                param = '?param=writingcontest2019page';
            }

            $.ajax({
                url: window.Config.BASE_PATH + '/api/v1/book/save-book-writing-contest' + param,
                type: 'post',
                dataType: 'json'
            });
        }

        if ($(this).attr('data-page') === 'filmmakers') {
            $.ajax({
                url: window.Config.BASE_PATH + '/api/v1/book/save-filmmakers',
                type: 'post',
                dataType: 'json'
            });
        }

        $('#' + popup).fadeIn();
        if ($(this).data('type') === 'login') {
            // $('.login-reg').trigger('click');
            // $('.sign-tabs .login-link').trigger('click');
            // show login form
            window.cbShowLoginForm();
        } else if ($(this).data('type') === 'register') {
            // $('.register-reg').trigger('click');
            // $('.sign-tabs .join-link').trigger('click');
            // show join form
            window.cbShowJoinForm();
        }

        if ($('#' + popup).is(':visible') === true) {
            l.stop();
        }
        //        $('html, body').css('overflow','hidden');
    });

    //Функционирование всплывающего окна при клике
    $(document).on('click', '.c-close, .c-popup-window .yc-return', function () {
        $('.c-popup').fadeOut();
        $('html, body').css('overflow', 'visible');
    });

    //функционал сообщений alert`ов
    $(document).on('click', '.close-alert', function () {
        $(this).parents('.alert-message').fadeOut();
    });

    $('.b2b-contact-form .send-b2b-contacts').on('click', function (e) {
        $('.alert-message').hide();
        e.preventDefault();

        if (typeof window['ga'] == 'function') ga('send', 'event', 'b2b', 'button', 'send-philanthropists');

        if (
            !$('.b2b-contact-form .first-name').val() ||
            !$('.b2b-contact-form .last-name').val() ||
            !$('.b2b-contact-form .b2b-email').val() ||
            !validateTextfield($('.b2b-contact-form .first-name')) ||
            !validateTextfield($('.b2b-contact-form .last-name')) ||
            !validateEmail($('.b2b-contact-form .b2b-email')) ||
            !validateTextfield($('.b2b-contact-form .b2b-company')) ||
            !validateMessageB2Bfield($('.b2b-contact-form .b2b-message'))
        ) {
            System.showErrors(locale['TEXT_PLEASE_COMPLETE_ALL_THE_REQUIRED_FIELDS_CORRECTLY'])
            return false;
        }

        var l = Ladda.create(this);
        l.start();
        var data = {
            'b2b_page_name': $('.b2b-contact-form .page-name').val(),
            'b2b_first_name': $('.b2b-contact-form .first-name').val(),
            'b2b_last_name': $('.b2b-contact-form .last-name').val(),
            'b2b_email': $('.b2b-contact-form .b2b-email').val(),
            'b2b_company': $('.b2b-contact-form .b2b-company').val(),
            'b2b_message': $('.b2b-contact-form .b2b-message').val()
        };
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/b2b/send-contacts',
            data: data,
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    if (data.b2b_page_name == 'For Philanthropists') {
                        if (typeof window['ga'] == 'function') ga('send', 'event', 'b2b', 'button', 'send-philanthropists-success');
                        if (typeof window['gtag'] == 'function') gtag('event', 'conversion', { 'send_to': 'AW-879451514/pV1HCIKr86sDEPq6raMD' })
                    }
                    System.notify(resp.message);
                    $('.b2b-contact-form input').val('');
                    $('.b2b-contact-form textarea').val('');
                    $('.b2b-contact-form .cb-form-control').removeClass('success');
                    l.stop();
                } else {
                    System.showErrors(resp.message);
                }
            }
        });
        return false;
    });

    $('.b2b-contact-form .send-b2b-contacts-producers').on('click', function (e) {
        $('.alert-message').hide();
        e.preventDefault();

        if (typeof window['ga'] == 'function') ga('send', 'event', 'b2b', 'button', 'send-producers');

        if (
            !$('.b2b-contact-form .first-name').val() ||
            !$('.b2b-contact-form .last-name').val() ||
            !$('.b2b-contact-form .b2b-email').val() ||
            !validateTextfield($('.b2b-contact-form .first-name')) ||
            !validateTextfield($('.b2b-contact-form .last-name')) ||
            !validateEmail($('.b2b-contact-form .b2b-email')) ||
            !validateMessageB2Bfield($('.b2b-contact-form .b2b-message'))
        ) {
            System.showErrors(locale['TEXT_PLEASE_COMPLETE_ALL_THE_REQUIRED_FIELDS_CORRECTLY'])
            return false;
        }

        var l = Ladda.create(this);
        l.start();
        var data = {
            'b2b_page_name': $('.b2b-contact-form .page-name').val(),
            'b2b_first_name': $('.b2b-contact-form .first-name').val(),
            'b2b_last_name': $('.b2b-contact-form .last-name').val(),
            'b2b_email': $('.b2b-contact-form .b2b-email').val(),
            'b2b_message': $('.b2b-contact-form .b2b-message').val()
        };
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/b2b/send-contacts-producers',
            data: data,
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    System.notify(resp.message);
                    $('.b2b-contact-form input').val('');
                    $('.b2b-contact-form textarea').val('');
                    $('.b2b-contact-form .cb-form-control').removeClass('success');
                    l.stop();
                } else {
                    System.showErrors(resp.message);
                }
            }
        });
        return false;
    });

    $('.register-b2c-user').on('click', function () {
        var l = Ladda.create(this);
        l.start();

        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/b2b/set-b2b-user',
            dataType: 'json',
            method: 'POST',
            success: function (resp) {
                if (resp.success) {
                    if (window.location.pathname == resp.data.url) {
                        window.location.reload(true);
                    } else {
                        window.location = resp.data.url;
                    }
                }
            }
        });
        return false;
    });

    //mobile menu
    $('.mobile-menu-button, .js-toggle-mobile-menu').on('click', function () {
        // if ($('.mobile-menu').hasClass('showed')) {
        //     $('.mobile-menu').removeClass('showed');
        //     $(this).removeClass('showed');
        //     $('html, body').removeClass('not-scrollable-body');
        //     $('.mobile-menu .sub-menu').removeClass('active');
        // } else {
        //     $('.mobile-menu').addClass('showed');
        //     $(this).addClass('showed');
        //     $('html, body').addClass('not-scrollable-body');
        // }
        $('.mobile-menu').toggleClass('showed');
        $(this).toggleClass('showed');
        $('body').toggleClass('not-scrollable-body');
    });

    $(document).on('mouseup touchend', function (e) {
        var div = $('.mobile-menu');
        if ((!div.is(e.target)
            && div.hasClass('showed')
            && div.has(e.target).length === 0)

        ) {
            div.removeClass('showed');
            $('body').toggleClass('not-scrollable-body');
        }
    });


    if ($(window).width() > 768) {
        var src = $('.slider .item > img').data('desktop');
        $('.slider .item > img').attr('src', src);
        $('.how-it-works-info').before('<div class="how-it-works-desk-v"><img src="/new_img/b2b/how-it-works_scheme-v3-993-min.png" alt="how it works" /></div>');
    } else {
        var src = $('.slider .item > img').data('mobile');
        $('.slider .item > img').attr('src', src);
    }

    $('.sign-tabs a').on('click', function () {

        var tab = $(this).attr('data-href');
        $('.sign-tabs a').removeClass('active');
        $(this).addClass('active');
        $('.sign-block').removeClass('choosen');
        $('.sign-block.' + tab).addClass('choosen');
    });

    //accordion start
    //accordion open active menu
    $('.accordion .select').parent().slideToggle(350);
    $('.accordion .select').parent().prev().addClass('opened');
    //accordion toggle
    $('.accordion .toggle').click(function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.next().hasClass('show')) {
            $this.removeClass('opened');
            $this.next().removeClass('show');

            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find('li .inner').removeClass('show');
            $this.parent().parent().find('li .pre-menu').removeClass('opened');
            $this.parent().parent().find('li .inner').slideUp(350);
            $this.next().toggleClass('show');
            $this.toggleClass('opened');
            $this.next().slideToggle(350);
        }
    });
    //accordion end

    $('.js-see-more-royalty-str').on('click', function () {
        $('.hidden-str').toggleClass('hidden');
        $(this).toggleClass('see-more--open');
        var text = $(this).text();
        $(this).text(
            text == "SHOW MORE" ? "SHOW LESS" : "SHOW MORE");
    });
});

var el = document.querySelector('.more-terms');
if (el) {
    el.addEventListener('click', function () {
        var hidden = document.querySelector('.hidden');
        this.remove();
        hidden.classList.toggle('show');
    });
}

function showJoinForm() {
    $('.open-join-form').addClass('hide').removeClass('show');
    $('.authors-join').addClass('show').removeClass('hide');
    $('.contact').addClass('hide').removeClass('show');
}

